import Plugin from 'src/plugin-system/plugin.class';

export default class HeaderPlugin extends Plugin {

    init() { 
        this._registerEvents();
        this._handleScroll();
    }

    _registerEvents() {
        $( window ).on('scroll', () => {
            this._handleScroll();
        });

        $( window ).on('resize', () => {
            this._handleResize();
        });

        this._initSubpagesNav();
        this._initMobileNav();
        this._initDesktopNav();
    }

    _handleScroll() {
        if ($(document).scrollTop() > 100) {
            this._showMinimalHeader();
        } else {
            this._hideMinimalHeader();
        }
    }

    _handleResize() {
        if ($(window).width() > 1100) {
            this._hideMobileNav();
        }
    }

    _initSubpagesNav() {
        $('.navbar-subpages__close').on('click', function() {
            $('.navbar-subpages').addClass('is--hidden');
        });
    }

    _showMinimalHeader() {
        $(this.el).addClass('is--on-scroll');
    }

    _hideMinimalHeader() {
        $(this.el).removeClass('is--on-scroll');
    }

    _showMobileNav() {
        $('.mobile-nav').addClass('is--visible');
        $('html, body').css({
            overflow: 'hidden',
            height: '100%'
        });
    }

    _hideMobileNav() {
        $('.mobile-nav').removeClass('is--visible');
        $('html, body').css({
            overflow: 'auto',
            height: 'auto'
        });

        $('.mobile-nav__nav .menu-das-unternehmen').removeClass('is--open');
        $('.mobile-nav__nav .menu-das-unternehmen .header__sub-nav__list').collapse('hide');
        
        $('.mobile-nav__nav .menu-leistungen').removeClass('is--open');
        $('.mobile-nav__nav .menu-leistungen .header__sub-nav__list').collapse('hide');

    }

    _initMobileNav() {

        var self = this;

        $('.mobile-nav__nav .menu-leistungen').append($('.leistungen-sub-nav ul').clone());
        $('.mobile-nav__nav .menu-leistungen .header__sub-nav__list').addClass('collapse');

        $('.mobile-nav__nav .menu-leistungen').on('click', function() {
            $('.mobile-nav__nav .menu-das-unternehmen').removeClass('is--open');
            $(this).toggleClass('is--open');
            $('.mobile-nav__nav .menu-leistungen .header__sub-nav__list').collapse('toggle');
            $('.mobile-nav__nav .menu-das-unternehmen .header__sub-nav__list').collapse('hide');
        });

        $('.mobile-nav__nav .menu-das-unternehmen').append($('.das-unternehmen-sub-nav ul').clone());
        $('.mobile-nav__nav .menu-das-unternehmen .header__sub-nav__list').addClass('collapse');

        $('.mobile-nav__nav .menu-das-unternehmen').on('click', function() {
            $('.mobile-nav__nav .menu-leistungen').removeClass('is--open');
            $(this).toggleClass('is--open');
            $('.mobile-nav__nav .menu-das-unternehmen .header__sub-nav__list').collapse('toggle');
            $('.mobile-nav__nav .menu-leistungen .header__sub-nav__list').collapse('hide');
        });

        $('.header__search-icon').on('click', function() {
            $('.header__mobile-search').addClass('is--visible');
            $('.header__mobile-search-bar .form-control').focus();
        });

        $('.header__mobile-search-bar .is--close').on('click', function() {
            $('.header__mobile-search').removeClass('is--visible');
        });

        $('.header__burger').on('click', function() {
            self._showMobileNav();
        });

        $('.mobile-nav__close').on('click', function() {
            self._hideMobileNav();
        });
    }

    _initDesktopNav() {
        var $leistungenMenu = $('.header-desktop .menu-leistungen .nav-link');
        var $dasUnternehmenMenu = $('.header-desktop .menu-das-unternehmen .nav-link');

        var $leistungenSubNav = $('.header-desktop .leistungen-sub-nav');
        var $dasUnternehmenSubNav = $('.header-desktop .das-unternehmen-sub-nav');

        // Leistungen
        $dasUnternehmenMenu.mouseenter(function(){
            $leistungenSubNav.removeClass('is--visible');
            $dasUnternehmenMenu.removeClass('is--active');
        });

        $leistungenMenu.mouseenter(function(){
            $dasUnternehmenMenu.addClass('is--active');
            $leistungenSubNav.addClass('is--visible');
        });

        // Das Unternehmen
        $leistungenMenu.mouseenter(function(){
            $dasUnternehmenSubNav.removeClass('is--visible');
            $leistungenMenu.removeClass('is--active');
        });

        $dasUnternehmenMenu.mouseenter(function(){
            $leistungenMenu.addClass('is--active');
            $dasUnternehmenSubNav.addClass('is--visible');
        });

        // Close buttons
        $('.header__sub-nav__close').on('click', function() {
            $leistungenSubNav.removeClass('is--visible');
            $dasUnternehmenSubNav.removeClass('is--visible');
            $leistungenMenu.removeClass('is--active');
            $dasUnternehmenMenu.removeClass('is--active');
        });
    }

}